/* IntelApps — FAQ Section */
import React from 'react';
import { Link } from 'react-router-dom';
import { Arrow } from './Header.js';
import { useI18n } from '../i18n.js';

export default function FAQSection() {
  const { t } = useI18n();

  const faqs = [
    { q: t.faq.items.q1.q, a: t.faq.items.q1.a },
    { q: t.faq.items.q2.q, a: t.faq.items.q2.a },
    { q: t.faq.items.q3.q, a: t.faq.items.q3.a },
    { q: t.faq.items.q4.q, a: t.faq.items.q4.a },
    { q: t.faq.items.q5.q, a: t.faq.items.q5.a },
    { q: t.faq.items.q6.q, a: t.faq.items.q6.a },
  ];

  return (
    <section className="section" id="faq">
      <div className="container faq-wrap">
        <div>
          <span className="eyebrow">{t.faq.eyebrow}</span>
          <h2 style={{
            fontFamily: 'Plus Jakarta Sans',
            fontSize: 'clamp(36px, 4vw, 48px)',
            fontWeight: 700,
            letterSpacing: '-0.03em',
            lineHeight: 1,
            margin: '12px 0 16px',
          }}
          >
            {t.faq.title}
          </h2>
          <p style={{ color: 'var(--ink-3)', fontSize: 16, lineHeight: 1.55 }}>
            {t.faq.description}
          </p>
          <Link to="/discuss-project" className="btn btn-primary btn-arrow" style={{ marginTop: 24 }}>
            {t.faq.cta} <Arrow size={14} />
          </Link>
        </div>
        <div className="faq">
          {faqs.map((f) => (
            <details className="faq-item" key={f.q}>
              <summary className="faq-q">
                {f.q}
                <span className="faq-toggle">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                    <path d="M12 5v14M5 12h14" />
                  </svg>
                </span>
              </summary>
              <p className="faq-a">{f.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
